import {Component} from 'react'
import {Redirect} from 'react-router-dom'
import Cookies from 'js-cookie'
import {FaFire} from 'react-icons/fa'

import AppContext from '../../context/AppContext'

import Loader from '../Loader'
import VideoCard from '../VideoCard'
import FailureView from '../FailureView'
import Header from '../Header'
import SideBar from '../SideBar'

import {
  TrendingContainer,
  TrendingHeader,
  TrendingIconContainer,
  TrendingIcon,
  TrendingPara,
  TrendingVideos,
} from './styledComponents'

const apiStatusConstants = {
  initial: 'INITIAL',
  success: 'SUCCESS',
  failure: 'FAILURE',
  inProgress: 'IN PROGRESS',
}

class Trending extends Component {
  state = {apiStatus: apiStatusConstants.initial, trendingVideosList: []}

  componentDidMount() {
    this.getTrendingApiCall()
  }

  onClickTrendingRetryBtn = () => {
    this.getTrendingApiCall()
  }

  getTrendingApiCall = async () => {
    this.setState({apiStatus: apiStatusConstants.inProgress})
    const jwtToken = Cookies.get('jwt_token')
    const url = 'https://apis.ccbp.in/videos/trending'
    const options = {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
      method: 'GET',
    }
    const response = await fetch(url, options)
    if (response.ok === true) {
      const data = await response.json()
      const formattedData = data.videos.map(each => ({
        id: each.id,
        title: each.title,
        thumbnailUrl: each.thumbnail_url,
        viewCount: each.view_count,
        publishedAt: each.published_at,
        channel: {
          name: each.channel.name,
          profileImageUrl: each.channel.profile_image_url,
        },
      }))
      this.setState({
        apiStatus: apiStatusConstants.success,
        trendingVideosList: formattedData,
      })
    } else {
      this.setState({apiStatus: apiStatusConstants.failure})
    }
  }

  renderSuccessView = () => {
    const {trendingVideosList} = this.state
    return (
      <AppContext.Consumer>
        {value => {
          const {theme} = value
          return (
            <TrendingContainer theme={theme} data-testid="trending">
              <TrendingHeader theme={theme}>
                <TrendingIconContainer theme={theme}>
                  <TrendingIcon fill="#ff0000" as={FaFire} />
                </TrendingIconContainer>
                <TrendingPara theme={theme}>Trending</TrendingPara>
              </TrendingHeader>
              <TrendingVideos theme={theme}>
                {trendingVideosList.map(each => (
                  <VideoCard videoItem={each} key={each.id} />
                ))}
              </TrendingVideos>
            </TrendingContainer>
          )
        }}
      </AppContext.Consumer>
    )
  }

  render() {
    const {apiStatus} = this.state
    const jwtToken = Cookies.get('jwt_token')
    const {match} = this.props
    const {path} = match
    if (jwtToken === undefined) {
      return <Redirect to="/login" />
    }
    return (
      <div data-testid="trending">
        <Header />
        <SideBar path={path} />
        {(() => {
          switch (apiStatus) {
            case apiStatusConstants.inProgress:
              return <Loader />
            case apiStatusConstants.failure:
              return (
                <FailureView
                  trendingRetryBtn={this.onClickTrendingRetryBtn}
                  path={path}
                />
              )
            case apiStatusConstants.success:
              return this.renderSuccessView()
            default:
              return null
          }
        })()}
      </div>
    )
  }
}

export default Trending
